import { Routes } from '@angular/router';

import { LayoutComponent } from './layout.component';

import {
  ErrorComponent,
  LandingComponent,
  LoginRedirectComponent,
  NotFoundComponent,
} from './pages';
import { LoginComponent } from './pages/login/login.component';

export const LandingRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LandingComponent,
  },
  {
    path: 'about',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/about/about.component').then((m) => m.AboutComponent),
        title: 'About',
      },
    ],
  },
  {
    path: 'error',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: ErrorComponent,
      },
    ],
  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
  },
  {
    path: 'idp-handler',
    component: LoginRedirectComponent,
  },
  {
    path: 'session-timeout',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/session-timeout/session-timeout.component').then(
            (m) => m.SessionTimeoutComponent,
          ),
      },
    ],
  },
  {
    path: 'terms',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/terms-conditions/terms-conditions.component').then(
            (m) => m.TermsConditionsComponent,
          ),
        title: 'Terms & Conditions',
      },
    ],
  },
  {
    path: 'privacy-compliance-policy',
    component: LayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './pages/privacy-compliance-policy/privacy-compliance-policy.component'
          ).then((m) => m.PrivacyCompliancePolicyComponent),
        title: 'Privacy and Compliance Statement',
      },
    ],
  },
  {
    path: 'page-not-found',
    component: NotFoundComponent,
  },
];
